function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Component } from "react";
import ReactTooltip from "react-tooltip";
import VolumeSlider from "./VolumeSlider";
import { KEY_ENTER, KEY_SPACE, TOOLTIP_SHOW_DELAY, VOLUME_MAX, VOLUME_MIN, VOLUME_STEP } from "@config/constants";
import { isCastAvailable } from "@common/services/helpers";
var VolumeButton = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(VolumeButton, Component);
    var _super = _create_super(VolumeButton);
    function VolumeButton(props) {
        _class_call_check(this, VolumeButton);
        var _this;
        _this = _super.call(this, props);
        var _props_videoPlayer_video = props.videoPlayer.video, volume = _props_videoPlayer_video.volume, lastPositiveVolume = _props_videoPlayer_video.lastPositiveVolume;
        // Set current volume
        _this.state = {
            isMuted: props.videoPlayer.video.muted,
            currentVolume: volume >= VOLUME_MIN ? volume : VOLUME_MAX,
            lastPositiveVolume: lastPositiveVolume || VOLUME_MAX,
            isSliderShown: false
        };
        _this.timeOut = null;
        _this.toggleVolumeFromButton = _this.toggleVolumeFromButton.bind(_assert_this_initialized(_this));
        _this.changeVolumeFromSlider = _this.changeVolumeFromSlider.bind(_assert_this_initialized(_this));
        _this.changeVolume = _this.changeVolume.bind(_assert_this_initialized(_this));
        _this.toggleVolumeFromKeyboard = _this.toggleVolumeFromKeyboard.bind(_assert_this_initialized(_this));
        _this.showSlider = _this.showSlider.bind(_assert_this_initialized(_this));
        _this.hideSlider = _this.hideSlider.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(VolumeButton, [
        {
            /**
     * Toggle volume from button
     * @param isTriggeredFromKeyboard {Boolean}
     */ key: "toggleVolumeFromButton",
            value: function toggleVolumeFromButton(isTriggeredFromKeyboard) {
                var _this = this;
                var actions = this.props.actions;
                this.setState(function(prevState) {
                    var volume = prevState.isMuted ? Number.parseFloat(prevState.lastPositiveVolume) : VOLUME_MIN;
                    volume === VOLUME_MIN ? actions.toggleMute(true) : actions.toggleMute(false);
                    _this.changeVolume(volume, isTriggeredFromKeyboard);
                    if (isCastAvailable()) {
                        var castSession = cast.framework.CastContext.getInstance().getCurrentSession();
                        if (castSession) {
                            if (!prevState.isMuted) {
                                castSession.setMute(true);
                            } else {
                                castSession.setMute(false);
                                castSession.setVolume(prevState.lastPositiveVolume);
                            }
                        }
                    }
                    return {
                        isMuted: !prevState.isMuted,
                        currentVolume: volume
                    };
                });
            }
        },
        {
            /**
     * Change volume from slider
     * @params event {Object} isTriggeredFromKeyboard {Boolean}
     */ key: "changeVolumeFromSlider",
            value: function changeVolumeFromSlider(event, isTriggeredFromKeyboard) {
                var _this = this;
                var volume = null;
                var parsedValue = Number.parseFloat(event.target.value);
                if (parsedValue <= VOLUME_MIN) {
                    volume = parsedValue;
                    this.setState(function() {
                        return {
                            isMuted: true,
                            currentVolume: volume
                        };
                    });
                } else {
                    volume = Math.min(parsedValue, VOLUME_MAX);
                    this.setState(function() {
                        return {
                            isMuted: false,
                            currentVolume: volume,
                            lastPositiveVolume: volume
                        };
                    });
                }
                clearTimeout(this.timeOut);
                this.timeOut = setTimeout(function() {
                    return _this.changeVolume(volume, isTriggeredFromKeyboard);
                }, 100);
                if (isCastAvailable()) {
                    var castSession = cast.framework.CastContext.getInstance().getCurrentSession();
                    if (castSession) {
                        castSession.setVolume(volume);
                    }
                }
            }
        },
        {
            /**
     * Change volume in store
     * @params  value {number} isTriggeredFromKeyboard {Boolean}
     */ key: "changeVolume",
            value: function changeVolume(value, isTriggeredFromKeyboard) {
                this.props.actions.setVolume(value, isTriggeredFromKeyboard);
            }
        },
        {
            /**
     * Toggle volume on space or enter key down
     * @param event
     */ key: "toggleVolumeFromKeyboard",
            value: function toggleVolumeFromKeyboard(event) {
                var key = event.which;
                if (key === KEY_SPACE || key === KEY_ENTER) {
                    event.stopPropagation();
                    this.toggleVolumeFromButton(true);
                }
            }
        },
        {
            /**
     * Show slider when hovered
     */ key: "showSlider",
            value: function showSlider() {
                this.setState({
                    isSliderShown: true
                });
            }
        },
        {
            /**
     * Show slider when hovered
     */ key: "hideSlider",
            value: function hideSlider() {
                this.setState({
                    isSliderShown: false
                });
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
                var _this_state = this.state, currentVolume = _this_state.currentVolume, isSliderShown = _this_state.isSliderShown;
                return currentVolume !== nextState.currentVolume || isSliderShown !== nextState.isSliderShown;
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(param) {
                var videoPlayer = param.videoPlayer;
                var volume = videoPlayer.video.volume;
                if (volume && this.props.videoPlayer.video.volume !== volume) {
                    this.setState({
                        currentVolume: videoPlayer.video.volume
                    });
                    volume && volume <= VOLUME_STEP ? this.setState({
                        isMuted: true,
                        currentVolume: VOLUME_MIN
                    }) : this.setState({
                        isMuted: false
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_state = this.state, isMuted = _this_state.isMuted, currentVolume = _this_state.currentVolume, isSliderShown = _this_state.isSliderShown;
                var _this_props = this.props, i18n = _this_props.i18n, screenType = _this_props.screenType;
                var buttonStateClass = isMuted ? "icon-volume-off" : "icon-volume-up";
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(ReactTooltip, {
                            id: "volume-tooltip",
                            className: "tooltip",
                            place: "bottom",
                            delayShow: TOOLTIP_SHOW_DELAY,
                            effect: "solid",
                            disable: !screenType.web,
                            getContent: [
                                function() {
                                    return !isMuted ? i18n.player.soundOff : i18n.player.soundOn;
                                }
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "volume-button player-button",
                            onMouseEnter: this.showSlider,
                            onMouseLeave: this.hideSlider,
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "icon control pointer ".concat(buttonStateClass),
                                    onClick: function() {
                                        return _this.toggleVolumeFromButton(false);
                                    },
                                    onKeyDown: this.toggleVolumeFromKeyboard,
                                    "data-for": "volume-tooltip",
                                    "data-tip": !isMuted ? i18n.player.soundOff : i18n.player.soundOn,
                                    tabIndex: "0"
                                }),
                                typeof currentVolume !== "undefined" && !screenType.tablet && !screenType.mobile ? /*#__PURE__*/ _jsx(VolumeSlider, {
                                    volume: currentVolume,
                                    onVolumeChange: this.changeVolumeFromSlider,
                                    showSlider: this.showSlider,
                                    hideSlider: this.hideSlider,
                                    isSliderShown: isSliderShown
                                }) : null
                            ]
                        })
                    ]
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                clearTimeout(this.timeOut);
            }
        }
    ]);
    return VolumeButton;
}(Component);
export default VolumeButton;
